import styled from "styled-components/native";
import BaseTheme from "@fkhplus/common/src/styles/themes/Base";
import { ITheme } from '@fkhplus/common/src/styles/themes/interface';

export type LabelType = 'labelXss' | 'labelXs' | 'labelSmall' | 'labelMedium' | 'labelLarge';
export type TitleType = 'titleLarge' | 'titleMedium';
export type BodyType = 'bodyRegular' | 'bodyMedium' | 'bodyLarge';
export type HeadlineType = 'headlineRegular' | 'headlineMedium' | 'headlineLarge';

export type TextType =   HeadlineType | TitleType | BodyType | LabelType;
export type FontType = 'regular' | 'medium' | 'bold';
export type FontWeightType = 'normal' | 'medium' | 'bold';

interface IFontElements {
    size: string;
    lineHeight: string;
    fontFamily: string;
    fontWeight: number;
    color: string;
}

export interface IStyleProp {
    fontType?: FontType,
    fontWeight?: FontWeightType
    color?: string;
}

export const defaultStyle: IStyleProp = {
    fontType: 'regular',
    fontWeight: 'normal',
    color: '#2D3037',
}

// TODO: SKV|16-FEB-2022|Need to to check font-stack for web and Multilingual font support
const getFontElements = (theme: ITheme, type: TextType, styleProp: IStyleProp): IFontElements => {
    const { font, fontWeight: weights, fontFamily } = theme.typography;
    const {
        fontType = 'regular',
        fontWeight = 'normal',
        color = theme.palette.neutral.greys800 as string
    } = styleProp;

    return {
        size: font[type].size,
        lineHeight: font[type].lineHeight,
        fontFamily: fontFamily[fontType],
        fontWeight: weights[fontWeight],
        color,
    }
}

export const Typography = styled.Text<{ type: any, styleProp: IStyleProp }>`
  font-size: ${props => getFontElements(props.theme as ITheme, props.type, props.styleProp).size};
  line-height: ${props => getFontElements(props.theme as ITheme, props.type, props.styleProp).lineHeight};
  font-family: ${props => getFontElements(props.theme as ITheme, props.type, props.styleProp).fontFamily};
  font-weight: ${props => getFontElements(props.theme as ITheme, props.type, props.styleProp).fontWeight};
  color: ${props => getFontElements(props.theme as ITheme, props.type, props.styleProp).color};
`
